module.exports = __webpack_public_path__ + "img/5bombas.c38fe404.jpg";